import React, { useEffect } from 'react'
import Additional from './Additional'
import Comment from './Comment'

const Digitalmarketing = () => {
  useEffect(() => {
    window.scrollTo(900, 900);
  }, []);
  return (
    <div>
        <div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s">
  <div className="container py-5">
    <div className="row g-5">
      <div className="col-lg-8">
        {/* Course Detail Start */}
        <div className="mb-5">
          <h1 className="mb-4">Digital Marketing Course</h1>
          <p>Explore the comprehensive syllabus of our Digital Marketing course, designed to equip you with practical skills and hands-on experience to thrive in the world of digital marketing. Our experienced trainers guide you through each topic, ensuring you're industry-ready upon course completion. Join us at Acrosys Technologies for this transformative learning experience.</p>
          {/* Sessions */}
          <p><b>Session 1: Introduction to Digital Marketing</b></p>
          <p>Digital marketing overview, importance, and key concepts</p>
          <b>Session 2: Website Creation and Optimization</b>
          <p>Creating and optimizing websites for better user experience and search engine visibility</p>
          {/* ... Other sessions ... */}
          <b>Session 3: Social Media Marketing</b>
          <p>Strategies and techniques for effective social media marketing</p>
          <b>Session 4: Email Marketing</b>
          <p>Creating engaging email campaigns and managing email marketing efforts</p>
          {/* ... Other sessions ... */}
          <b>Session 5: Analytics and Reporting</b>
          <p>Measuring and analyzing digital marketing campaign performance</p>
        </div>
        <div className="mb-5">
                <div className="section-title section-title-sm position-relative pb-3 mb-4">
                  <h3 className="mb-0">Comments</h3>
                </div>
              </div>
              {/* Comment List End */}
              {/* Comment Form Start */}
              <Comment/>
              {/* Comment Form End */}
            </div>
            {/* Sidebar Start */}
            <div className="col-lg-4">
              {/* Search Form Start */}
              <Additional/>
            </div>
            {/* Sidebar End */}
          </div>
        </div>
      </div>

    </div>
  )
}

export default Digitalmarketing